import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MemberNotificationService } from '../../../shareModule/services/member-notification.service';
import { QUEST_STATUS } from 'src/app/admin/super-admin/quests/quests.component';
import { ViewProductDetailsComponent } from '../view-product-details/view-product-details.component';
import { AllNotificationsModalComponent } from './all-notifications-modal.component';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
export interface Notification {
  id: number | string;
  title: string;
  type: string;
  header: string;
  message: string;
  createDate: string;
  status: string;
  payload: Object | string;
}

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {
  public data: {
    title: string;
    description: string;
    type: string;
    payload: Object;
    id: string | number;
  } = { title: '', description: '', payload: {}, type: '', id: '' };

  notificationPopup: boolean = false;
  @ViewChild('clickSound') clickSound: any;
  timeoutId: any;

  @ViewChild('ViewProductDetailsComponent')
  viewProductDetailsComponent: ViewProductDetailsComponent;
  @Input() type: string = null;
  public selectedNotification: any;
  public notificationList: Array<Notification> = [];
  public status = QUEST_STATUS;
  public modalRef: any = null;

  showingAll = false;
  onDropdownOpen(isOpen) {
    if (isOpen) {
      this.allNotifications.forEach((notif: any) => {
        this.auth.updateNotificationIsRead(notif.id).subscribe(() => { });
      });
    } else {
      this._memberNotificationService.getNotification();
    }
  }

  showRecentNotifications() {
    this.showingAll = false;
    this.notificationList = this.allNotifications.filter((i: any) => {
      if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

      return i?.quest?.status != 4 && !i.isRead;
    });
  }
  showAllNotifications() {
    this.notificationList = this.allNotifications.filter((i: any) => {
      if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

      return i?.quest?.status != 4;
    });
    this.showingAll = true;
  }

  allNotifications: Notification[] = [];
  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _memberNotificationService: MemberNotificationService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this._memberNotificationService.notificationList.subscribe(
      (resp: Array<Notification>) => {
        this.notificationList = resp.filter((i: any) => {
          if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

          return i?.quest?.status != 4 && !i.isRead;
        });
        this.allNotifications = resp.filter((i: any) => {
          if (typeof i.payload != 'object') i.payload = JSON.parse(i.payload);

          return i?.quest?.status != 4;
        });

        if (this.notificationList.length > 0) {
          this.notifyUser(
            this.notificationList[0].title,
            this.notificationList[0].message,
            this.notificationList[0].type,
            this.notificationList[0].payload,
            this.notificationList[0].id
          );
        }
      }
    );
  }

  ngOnInit(): void {
    this._memberNotificationService.$notify.subscribe(
      (resp: { title: string; description: string }) => {
        this.notifyUser(resp.title, resp.description);
      }
    );
  }

  public popupClick() {
    if (this.data.type == 'chat-notif') {
      this.sharedService.triggerChatNow({
        chatingNow: this.data.payload['responseChatId'],
        menu: 'chat',
        chatTitle: null, //the component will get it
      });
    }

    console.log(this.data, "NOTIFICATION")
    if (this.data.type == 'giveaway') {
      this.router.navigate(['/giveaway'], { queryParams: { uuid: this.data.payload['uuid'] } })
    }
    this.notificationPopup = false;
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
    if (this.data.id) {
      this._memberNotificationService.clearNotificationById(this.data.id);
    }
  }

  public notifyUser(
    title: string,
    description: string,
    type = '',
    payload = {},
    id: string | number = ''
  ): void {
    this.data = { title: title, description: description, type, payload, id };
    this.notificationPopup = !this.notificationPopup;
    if (this.notificationPopup) this.clickSound.nativeElement.play();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId); // Clear the previous timeout
    }

    if (this.notificationPopup) {
      this.timeoutId = setTimeout(() => {
        this.notificationPopup = false;
        this.timeoutId = null; // Reset the timeout ID
      }, 5000);
    }
  }

  public openNotification(modal: any, selectedData) {
    this.selectedNotification = selectedData;
    console.log("this.selected", selectedData)
    if (this.selectedNotification.type == 'quest') {
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    } else if (this.selectedNotification.type == 'chat-notif') {
      this.sharedService.triggerChatNow({
        chatingNow: this.selectedNotification.payload['responseChatId'],
        menu: 'chat',
        chatTitle: null, //the component will get it
      });
    } else if (this.selectedNotification.type == 'giveaway') {
      console.log(this.selectedNotification.title.includes('Winner'))
      this.router.navigate(['/giveaway'], {
        queryParams: {
          uuid: this.selectedNotification.payload['uuid'],
          winner: this.selectedNotification.title.includes('Winner')
        }
      })
    }
  }

  public accept(status: number) {
    this.auth
      .updateQuestStatus(this.selectedNotification?.id, status)
      .subscribe((response: ApiResponse) => {
        this.toastr.success('Quest Accepted!');
        this.modalRef.close();
        this._memberNotificationService.getNotification();
      });
  }

  public closeNotification(selected: any) {
    this.auth
      .updateNotificationIsRead(selected.id)
      .subscribe((response: ApiResponse) => {
        this._memberNotificationService.getNotification();
      });
  }
}
